// extracted by mini-css-extract-plugin
export var closeButton = "_11-3";
export var header = "_11-0";
export var link = "_11-1";
export var retryButton = "_11-2";